var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-alert"},_vm._l((_vm.parseAlerts(_vm.data)),function(svg){return _c('img',{key:svg,staticClass:"alert-icon",attrs:{"src":svg}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }